import { Api } from 'models/services/api';
import { UpdateHeadquartersQuery } from 'models/services/graphql';

import { HeadquartersData, HeadquartersDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: HeadquartersDataToSave;
};

const RequestQuery = `
  mutation UpdateHeadquarters($id: ID!, $input: HeadquartersInput!) {
    ${UpdateHeadquartersQuery}
  }
`;

type ResponseData = {
  data: {
    updateHeadquarters: HeadquartersData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: HeadquartersData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateHeadquarters;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };